<!-----------------------------------------------------------------------------
  Copyright (c) 2016 - 2021.                                                  -
  Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti (Yega Yazilim)           -
  All Rights Reserved.                                                        -
                                                                              -
  The software and data contained herein are confidential and proprietary     -
  information of Yega Yazilim ("Confidential Information").                   -
                                                                              -
  Users of this software may not disclose such Confidential Information and   -
  shall use it only in accordance with the terms of the license agreement     -
  they entered into with Yega Yazilim.                                        -
                                                                              -
  Author:  Ahmet Dogramaci                                                    -
  Date:    2021-01-13                                                         -
  ----------------------------------------------------------------------------->

<template>

</template>

<script>
import idleTimeout from 'idle-timeout'

export default {
  name: "yega1-idle-watcher",
  props:{
    timeoutMinutes:{
      type: Number,
      default: 30
    }
  },
  mounted(){
    idleTimeout(()=>{this.$emit('timeout')},{
      timeout: 60*1000*this.timeoutMinutes
    });
  }
}
</script>

<style scoped>

</style>
